import { connect } from 'react-redux'

import { DELIVERY_OPTION } from '@cinch/oxd-containers/delivery-preference/src'
import { getDelivery } from '@cinch/oxd-redux/profile/src/selectors'
import { selectors as vehicleSelectors } from '@cinch/oxd-redux/dealer-vehicles/src'

import ListingResults from './listing-results.component'

interface PropsFromState {
  results: number[]
  isDelivery: boolean
  isPending: boolean
  isFetchComplete: boolean
  activePage: number
}

export const mapStateToProps = (state: any): PropsFromState => {
  const deliveryOption = getDelivery(state)
  const isDelivery = deliveryOption === DELIVERY_OPTION.DELIVERY

  return {
    results: vehicleSelectors.getListingResults(state),
    isDelivery,
    isPending: vehicleSelectors.getPredicate(state).listingsStatus.isPending,
    isFetchComplete: vehicleSelectors.getPredicate(state).listingsStatus.isComplete,
    activePage: state.entities.dealerListings.pageNumber,
  }
}

const connectedComponent = connect<PropsFromState, any, any>(mapStateToProps)(ListingResults)
export { PropsFromState }
export default connectedComponent
